<div fxLayout="row" fxLayoutAlign="start center">
  <mat-icon svgIcon="confirm" *ngIf="isCompatibleWithMachineQuality()"> </mat-icon>
  @if (!isCompatibleWithMachineQuality()) {
    <div [innerHTML]="reasonForIncompatibility" [matTooltip]="reasonForIncompatibility" class="reason-for-incompatibility"></div>
  }
</div>
